/**
 * Curated gallery for the site. Files live in `client/public/gallery/` (served as `/gallery/...`).
 * If you use GET /api/gallery for integrations, keep this list in sync with `server/data/gallery.json`.
 */
export const galleryPhotos = [
  {
    id: 'lab-line',
    type: 'image',
    title: 'Compounding line',
    url: '/gallery/lab-line.png',
    bytes: 70,
  },
  {
    id: 'quality-lab',
    type: 'image',
    title: 'Quality lab',
    url: '/gallery/quality-lab.png',
    bytes: 70,
  },
  {
    id: 'compounding-line',
    type: 'image',
    title: 'Plant compounding',
    url: '/gallery/compounding-line.png',
    bytes: 70,
  },
];

/** Add entries and place MP4/WebM files under `public/gallery/`. */
export const galleryVideos = [
  {
    id: 'sample-clip',
    type: 'video',
    title: 'Sample laboratory clip',
    url: '/gallery/sample-clip.webm',
    bytes: 554058,
  },
];
